import React from 'react';
import { lazyLoad } from '@react-page/editor';
const Panorama = lazyLoad(() => import('@mui/icons-material/Panorama'));
export const defaultTranslations = {
    pluginName: 'Clear Form',
    pluginDescription: 'Clear form input fields and reset states.',
    haveUrl: 'Existing image URL',
    or: 'OR',
    imageUrl: 'Icon URL',
    labelPlaceholder: 'Button',
    labelLabel: 'Button Label',
    hrefPlaceholder: 'http://example.com',
    hrefLabel: 'Link to open upon button click',
    srcPlaceholder: 'http://example.com/image.png',
    sizeLabel: 'Button Size',
    buttonSizeSmall: 'Small',
    buttonSizeMedium: 'Medium',
    buttonSizeLarge: 'Large',
    colorLabel: 'Button color',
    colorLabelPlaceholder: 'Hex color',
    // Strings used in ImageUpload
    buttonContent: 'Choose for upload',
    noFileError: 'No file selected',
    badExtensionError: 'Wrong file type',
    tooBigError: 'Image file > 5MB',
    uploadingError: 'Error while uploading',
    unknownError: 'Unknown error',
};
export const defaultSettings = {
    Controls: () => React.createElement(React.Fragment, null, " Controls for this plugin were not provided"),
    Renderer: () => React.createElement(React.Fragment, null, "Renderer; for this plugin was not provided "),
    translations: defaultTranslations,
    icon: React.createElement(Panorama, null),
    clearForm: () => React.createElement(React.Fragment, null, "ClearForm; for this plugin was not provided "),
};
//# sourceMappingURL=settings.js.map